<template>
  <div class="row m-0 align-items-center">
    <div class="col-7 offset-1">
      <div class="row m-0">
        <div class="col-12 p-0">
          <div class="leaderboard">{{ pos }} {{ fullName }}</div>
        </div>
      </div>
    </div>
    <div class="col-2 pr-0">
      <div class="row m-0">
        <div class="col-12 p-0">
         <div class="leaderboard">{{ timeTaken }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LeaderboardItem',
  props: ['pos', 'score'],
  computed: {
    fullName () {
      if (this.score.name === '') {
        return ''
      } else {
        return this.score.name + ' ' + this.score.surname
      }
    },
    timeTaken () {
      if (this.score.timeTaken === '') {
        return ''
      } else {
        return (this.score.timeTaken / 1000).toFixed(3)
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.leaderboard {
  background-color: #fff;
  margin-bottom: 1.2rem;
  border: none;
  box-shadow: 6px 6px 8px 0 rgba(0, 0, 0, 0.3);
  width: 100%;
  display: block;
  height: calc(2.25rem + 2px);
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  line-height: 1.5;
  color: #495057;
  border-radius: 0.25rem;
}
</style>



// WEBPACK FOOTER //
// src/components/partials/LeaderboardItem.vue